import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CommonService } from './common.service'
import { Router } from '@angular/router'
import { MessageService } from 'primeng/api';
import { AuthService } from './auth.service';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
import { Capacitor } from '@capacitor/core';
import { Subject } from 'rxjs';

declare var webengage
@Injectable({
  providedIn: 'root'
})

export class BillersService {

  biller
  details = false
  confirm = false
  complete = false
  finalData = { "amount_cad": null, "exchange_rate_cad": null, "transaction_fees": null, "gateway_fees": null, "total_amount": null,"payment_id":null ,"celoData": { "paymentSelectedoption": null }, "new_trans_fee": null }
  paymentMethod
  successAmount
  qr_code
  qr_amount
  ps_locations
  transaction_error = new Subject();
  constructor(public http: HttpClient,
    public common: CommonService,
    public router: Router,
    public message: MessageService,
    public auth: AuthService, private iab: InAppBrowser,
  ) { }

  getUserBillers(page) {
    return this.http.get(`${environment.api_link}/api/auth/biller-list?page=${page}`)
  }

  getCountries() {
    return this.http.post(`${environment.api_link}/api/biller-countries`, {});
  }

  getBillers(country) {
    return this.http.get(`${environment.api_link}/api/get-biller-catalog/${country}`)
  }

  getSkuCatalog(biller_id) {
    return this.http.get(`${environment.api_link}/api/auth/get-sku-catalog/${biller_id}`)
  }

  addBiller(data) {
    //console.log(data)
    return this.http.post(`${environment.api_link}/api/auth/save-biller`, data)
  }

  fetchBill(biller_id) {
    return this.http.get(`${environment.api_link}/api/auth/get-amount-due/${biller_id}`)
  }

  getBillAmount(currency, amount, payment_gateway_id = null) {
    let data = {
      source_currency: currency,
      source_amount: +amount,
      celo: 1,
      payment_gateway_id: payment_gateway_id
    }
    return this.http.post(`${environment.api_link}/api/auth/exchange-rate`, data)
  }

  getCeloBillAmount(celoObj) {
    let data = {
      source_currency: celoObj.currency,
      source_amount: +celoObj.amount,
      celo: 1,
      payment_gateway_id: celoObj.payment_gateways_id
    }
    return this.http.post(`${environment.api_link}/api/auth/exchange-rate`, data)
  }

  payToGateway() {
    webengage.track("Checkout Intiated", {
      "From Country": this.auth.user.country_id,
      "To country": this.biller.country_name,
      "Money Sent": this.finalData['amount_cad'],
      "Money Received": this.finalData['biller_amount_local'],
      "Sent Curency": this.auth.user.currency,
      "Received Currency": this.biller.currency
    })
    //console.log(this.paymentMethod, this.finalData, this.biller)
    if (this.paymentMethod.gateway_name == "PSI Gate") {
      let data = {
        receiver_id: this.biller.id,
        sending_amount: +this.finalData['amount_cad'],
        payment_type: this.paymentMethod['payment_option'],
        reason_code: 0,
        payment_gateway_id: this.paymentMethod.payment_id,
        transaction_type: 'biller',
        exchange_rate: this.finalData['exchange_rate_usd'],
        recipient_amount: this.finalData['biller_amount_local'],
        new_trans_fee: this.finalData['new_trans_fee'],
        discounted_amount: +this.finalData['amount_cad'],
        // coupon_id : 0
      }
      //this.common.showLoader()
      return this.http.post(environment.api_link + '/api/auth/send-money-via-psi', data).subscribe((res: any) => {
        localStorage.setItem('customerRefNo', res.customerRefNo)
        localStorage.setItem('recvName', this.biller.biller_name)
        let payByPSID
        if (this.paymentMethod.payment_option == "debit_card" || this.paymentMethod.payment_option == "credit_card") {
          payByPSID = {
            StoreKey: environment.PSI_STORE_KEY_CC,
            SubTotal: res.total_amount,
            Email: environment.BCC_MAIL_ADDRESS,
            PaymentType: "CC",
            CardAction: 0,
            CustomerRefNo: res.customerRefNo
          }
        }
        else if (this.paymentMethod.payment_option == "offline") {
          payByPSID = {
            StoreKey: environment.PSI_STORE_KEY_DB,
            SubTotal: res.total_amount,
            Email: environment.BCC_MAIL_ADDRESS,
            PaymentType: "DB",
            CardAction: 0,
            CustomerRefNo: res.customerRefNo
          }
        }
        this.postInNewTab(payByPSID)
        /* this.router.navigateByUrl("/pay-bill/biller5/") */
        /* this.confirmScreen=false */
        this.common.stopLoader()
      }, err => {
        // let errorKeys = Object.keys(err.error.errors);
        // errorKeys.forEach(key => {
        //   //console.log(key)
        //   let value = err.error.errors[key][0];
        //   this.messageService.add({ severity: 'error', summary: 'Error', detail: value });
        //   //console.log(value);
        // });
        // //console.log(err)
        this.common.stopLoader()
      })
    }

    else if (this.paymentMethod.gateway_name == "DC Bank" || this.paymentMethod.payment_id == 6) {
      if (this.paymentMethod.payment_option == "offline") {
        let data = {
          receiver_id: this.biller.id,
          sending_amount: +this.finalData['amount_cad'],
          // payment_type: this.paymentMethod['payment_option'], 
          reason_code: 0,
          payment_gateway_id: this.paymentMethod.payment_id,
          transaction_type: 'biller',
          exchange_rate: this.finalData['exchange_rate_usd'],
          recipient_amount: this.finalData['biller_amount_local'],
          new_trans_fee: this.finalData['new_trans_fee'],
          discounted_amount: +this.finalData['amount_cad'],
          celo_wallet_number: this.finalData['celoData']['celoWalletNumber'],
          // coupon_id : 0

        }
        this.sendViaDCOffline(data).subscribe((res: any) => {
          this.complete = true
          //console.log(res)
          this.successAmount = +(+res.total_amount).toFixed(2)
          webengage.track('pay_bill_confirm_and_pay', {
            status: 'Success',
            paymentGateway: this.paymentMethod.description
          })
          if (this.paymentMethod.payment_id == 6) {
            this.finalData['celoAmount'] = +res.celo_total_amount
            this.finalData['celoNumber'] = res.celo_wallet_number
            this.finalData['payment_id'] = res.payment_id
            this.finalData['celo_to_address'] = res.celo_to_address
            // this.router.navigateByUrl("/send-money/step6/" + res.trans_key)
            this.router.navigateByUrl("/pay-bill/biller6/" + res.trans_key)
            this.common.stopLoader()
          } else {
            this.router.navigateByUrl("/pay-bill/biller5/" + res.trans_key)
            this.common.stopLoader()
          }
        }, err => {
          //console.log(err)
          webengage.track('pay_bill_confirm_and_pay', {
            status: 'Failure',
            paymentGateway: this.paymentMethod.description
          })
          this.common.stopLoader();
          this.transaction_error.next(err.error.message)
          let errorKeys = Object.keys(err.error.errors);
          errorKeys.forEach(key => {
            //console.log(key)
            let value = err.error.errors[key][0];
            this.message.add({ severity: 'error', summary: 'Error', detail: value });
            //console.log(value);
          });
          //console.log(err)
          this.common.stopLoader()
        })
      }
      // else if (this.selectedCAPaymentMethod.payment_option == "bank") {
      //   this.common.showLoader()
      //   //console.log("bank")
      //   let data = {
      //     receiver_id: this.receiver.id,
      //     sending_amount: this.transactionDetails.sending_amt,
      //     reason_code: this.purpose.reason_code,
      //     payment_gateway_id: this.selectedCAPaymentMethod.payment_gateways_id
      //   }
      //   if (!this.auth.user.interac_email_id) {
      //     //console.log("creating account")
      //     this.createDCAccount().subscribe(res => {
      //       //console.log(res)
      //       this.sendmoneyViaDCBank(data).subscribe((res:any) => {
      //         //console.log(res)
      //         if(!res.error_code){
      //           this.isdcBankTransactionfaild=true
      //         }
      //         this.common.stopLoader()
      //         this.router.navigateByUrl("/send-money/step5/")
      //       }, err => {
      //         let errorKeys = Object.keys(err.error.errors);
      //         errorKeys.forEach(key => {
      //           //console.log(key)
      //           let value = err.error.errors[key][0];
      //           this.messageService.add({ severity: 'error', summary: 'Error', detail: value });
      //           //console.log(value);
      //         });
      //         //console.log(err)
      //         this.common.stopLoader()
      //       })
      //     }, err => {
      //       let errorKeys = Object.keys(err.error.errors);
      //       errorKeys.forEach(key => {
      //         //console.log(key)
      //         let value = err.error.errors[key][0];
      //         this.messageService.add({ severity: 'error', summary: 'Error', detail: value });
      //         //console.log(value);
      //       });
      //       //console.log(err)
      //       this.common.stopLoader()
      //     })
      //   } else {
      //     //console.log("email presenr")
      //     this.sendmoneyViaDCBank(data).subscribe(res => {
      //       //console.log(res)
      //       this.common.stopLoader()
      //       this.router.navigateByUrl("/send-money/step5")
      //     }, err => {
      //       let errorKeys = Object.keys(err.error.errors);
      //       errorKeys.forEach(key => {
      //         //console.log(key)
      //         let value = err.error.errors[key][0];
      //         this.messageService.add({ severity: 'error', summary: 'Error', detail: value });
      //         //console.log(value);
      //       });
      //       //console.log(err)
      //       this.common.stopLoader()
      //     })
      //   }

      // }
    }
    else if (this.paymentMethod.gateway_name == "Payment Source") {
      this.common.showLoader()
      let data = {
        receiver_id: this.biller.id,
        sending_amount: +this.finalData['amount_cad'],
        payment_type: this.paymentMethod['payment_option'],
        reason_code: 0,
        payment_gateway_id: this.paymentMethod.payment_id,
        transaction_type: 'biller',
        exchange_rate: this.finalData['exchange_rate_usd'],
        recipient_amount: this.finalData['biller_amount_local'],
        new_trans_fee: this.finalData['new_trans_fee'],
        discounted_amount: +this.finalData['amount_cad'],
        // coupon_id : 0
      }
      data.transaction_type = "biller"
      this.sendMoneyViaPaymentSource(data).subscribe((res: any) => {
        this.complete = true
        this.qr_code = res.qr_code
        this.qr_amount = res.total_amount
        this.common.stopLoader()
        webengage.track('pay_bill_confirm_and_pay', {
          status: 'Success',
          paymentGateway: this.paymentMethod.description
        })
        this.getLocationByPostalCode(this.auth.user.zip_code, 1).subscribe((res: any) => {
          this.ps_locations = res.data.data
          this.router.navigateByUrl("/pay-bill/biller5?payment-source-qr=true")
        }, err => {
          this.ps_locations = []
          this.router.navigateByUrl("/pay-bill/biller5?payment-source-qr=true")

        })
        // this.getLocations(res.tid).subscribe((res:any) => {
        //   this.ps_locations = res.data
        //   this.router.navigateByUrl("/pay-bill/biller5?payment-source-qr=true")
        // }, err => {
        //   this.ps_locations = []
        //   this.router.navigateByUrl("/pay-bill/biller5?payment-source-qr=true")
        // })
      }, err => {
        //console.log(err)
        webengage.track('pay_bill_confirm_and_pay', {
          status: 'Failure',
          paymentGateway: this.paymentMethod.description
        })
        this.common.stopLoader()
      })

    }


  }

  postInNewTab(obj) {
    // var psiform = document.createElement("form");
    // psiform.method = "POST"; // or "post" if appropriate
    // psiform.action = environment.PSI_FORM_URL;
    // //console.log(obj)
    // Object.keys(obj).forEach(function (param) {
    //   var mapInput = document.createElement("input");
    //   mapInput.type = "hidden";
    //   mapInput.name = param;
    //   mapInput.setAttribute("value", obj[param]);
    //   psiform.appendChild(mapInput);
    // });
    // //console.log(psiform)
    // document.body.appendChild(psiform);
    // psiform.submit();
    let myInterval = setInterval(() => {
      this.http.get(`${environment.api_link}/api/trans_details/${obj.CustomerRefNo}`).subscribe((res: any) => {
        //console.log(res)
        if (res.trans_status) {
          if (res.trans_status == 'Successful') {
            this.auth.get_monthly_limit(this.auth.user.id)
            webengage.track('pay_bill_confirm_and_pay', {
              status: 'Success',
              paymentGateway: this.paymentMethod.description
            })
            this.router.navigateByUrl('/send-money/step5?success=Successful')
            clearInterval(myInterval)
            browser.close()
          }
          else if (res.trans_status == 'Unsuccessful') {
            webengage.track('pay_bill_confirm_and_pay', {
              status: 'Failure',
              paymentGateway: this.paymentMethod.description
            })
            this.router.navigateByUrl('/send-money/step5?error=Unsuccessful')
            clearInterval(myInterval)
            browser.close()
          }

        }
      })
    }, 1500)
    let options: any = {
      location: 'yes',//Or 'no' 
      hidden: 'no', //Or  'yes' 
      hideurlbar: 'yes',//Or 'no'
      toolbar: 'yes',
      hidenavigationbuttons: 'yes',
      mediaPlaybackRequiresUserAction: 'yes',
      allowInlineMediaPlayback: 'yes'
    };
    let target = "_self"
    if (Capacitor.getPlatform() === 'android') {
      target = "_blank"
    }

    const browser = this.iab.create(environment.api_link + `/psi-html?PaymentType=${obj['PaymentType']}&SubTotal=${obj['SubTotal']}&CustomerRefNo=${obj['CustomerRefNo']}`, target, options);
    browser.on('exit').subscribe(() => {
      clearInterval(myInterval)
      this.common.stopLoader()
    }, err => {
      console.error(err);
    });
  }

  sendViaDCOffline(data) {

    return this.http.post(environment.api_link + '/api/auth/send-money-via-dc-interac', data)
  }

  sendMoneyViaPaymentSource(data) {
    return this.http.post(environment.api_link + '/api/auth/send-money-via-payment-source', data)
  }

  nextPage(page) {
    this.router.navigateByUrl(`/pay-bill/${page}`)
  }

  prevPage(page) {
    this.router.navigateByUrl(`/pay-bill/${page}`)
  }

  RemoveBiller(id) {
    return this.http.get(`${environment.api_link}/api/auth/delete-biller/${id}`)
  }
  // getLocations(id){
  //   return this.http.get(`${environment.api_link}/api/location-list`, {
  //     params:{
  //       txn_id : id
  //     }
  //   })
  // }

  getLocationByPostalCode(postal, page) {
    return this.http.get(`${environment.api_link}/api/list-location?postal_code=${postal}&type=biller&page=${page}`)
  }

}